import React, { useState, useEffect } from 'react';
import { ConnectButton, TransactionButton, useActiveAccount } from "thirdweb/react";
import { prepareContractCall, toWei } from "thirdweb";
import { client, contract } from "./client";
import { createClient } from "@supabase/supabase-js";

// Initialize Supabase
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY
);

function App() {
  const account = useActiveAccount();
  const [invId, setInvId] = useState("");
  const [amount, setAmount] = useState("");
  const [marketplaceInvoices, setMarketplaceInvoices] = useState([]);

  const refreshMarketplace = async () => {
    const { data } = await supabase.from("invoices").select("*").order("created_at", { ascending: false });
    setMarketplaceInvoices(data || []);
  };

  useEffect(() => {
    refreshMarketplace();
    const channel = supabase.channel("realtime_invoices")
      .on("postgres_changes", { event: "*", schema: "public", table: "invoices" }, refreshMarketplace)
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, []);

  return (
    <div style={{ padding: "40px", fontFamily: 'Segoe UI', maxWidth: "1200px", margin: "auto" }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px" }}>
        <h1 style={{ color: "#000000", margin: 0 }}>
          Invoice.OS <small style={{ fontSize: "0.4em", color: "#666" }}>v2 Marketplace</small>
        </h1>
        
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {/* CHAINLINK PROOF OF RESERVE BADGE */}
          <a 
            href="https://data.chain.link/feeds/base/base/cbbtc-por" 
            target="_blank" 
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          >
            <img 
              src="https://chain.link/badge-proof-of-reserve-black" 
              alt="Proof of Reserve Secured with Chainlink" 
              style={{ height: "38px", display: "block" }} 
            />
          </a>

          <ConnectButton client={client} />
        </div>
      </header>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: "50px" }}>
        
        {/* LEFT: SUPPLIER PANEL */}
        <section style={{ background: "#f8f9fa", padding: "30px", borderRadius: "15px", boxShadow: "0 4px 6px rgba(0,0,0,0.05)" }}>
          <h2 style={{ marginTop: 0 }}>Supplier Portal</h2>
          <p style={{ color: "#666" }}>Tokenize your unpaid invoices for instant liquidity.</p>
          
          <div style={{ marginBottom: "20px" }}>
            <label style={labelStyle}>Invoice Reference ID</label>
            <input placeholder="INV-2026-001" style={inputStyle} value={invId} onChange={(e) => setInvId(e.target.value)} />
            
            <label style={labelStyle}>Amount (in POL/ETH)</label>
            <input type="number" placeholder="e.g. 0.5" style={inputStyle} value={amount} onChange={(e) => setAmount(e.target.value)} />
          </div>

          <TransactionButton
            transaction={() => prepareContractCall({
              contract,
              method: "function tokenizeInvoice(string _id, uint256 _amt)",
              // FIX: Using toWei instead of raw BigInt for the amount
              params: [invId, toWei(amount || "0")],
            })}
            onTransactionSent={async () => {
              await supabase.from("invoices").insert([{ 
                invoice_id: invId, 
                amount: Number(amount), 
                owner_address: account?.address 
              }]);
              setInvId(""); setAmount("");
            }}
            onTransactionConfirmed={() => alert("Success: Invoice Minted & Listed!")}
          >
            List Invoice for Sale
          </TransactionButton>
        </section>

        {/* RIGHT: INVESTOR MARKETPLACE */}
        <section>
          <h2>Active Marketplace</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            {marketplaceInvoices.map((inv) => (
              <div key={inv.id} style={cardStyle}>
                <div style={{ marginBottom: "15px" }}>
                  <span style={{ fontSize: "0.8em", color: "#228be6", fontWeight: "bold" }}>RWA TOKEN</span>
                  <h3 style={{ margin: "5px 0" }}>{inv.invoice_id}</h3>
                  <p style={{ margin: 0, fontSize: "1.2em", fontWeight: "bold" }}>{inv.amount} ETH</p>
                  <small style={{ color: "#999" }}>Supplier: {inv.owner_address ? `${inv.owner_address.slice(0,6)}...${inv.owner_address.slice(-4)}` : "Unknown"}</small>
                </div>

                <TransactionButton
                  transaction={() => prepareContractCall({
                    contract,
                    method: "function buyInvoice(string _id)",
                    params: [inv.invoice_id],
                    value: toWei(inv.amount.toString()),
                  })}
                  onTransactionConfirmed={async () => {
                    await supabase.from("invoices").delete().eq("invoice_id", inv.invoice_id);
                    alert("Purchased! The supplier has been paid.");
                  }}
                  style={{ width: "100%", backgroundColor: "#40c057" }}
                >
                  Fund Invoice
                </TransactionButton>
              </div>
            ))}
            {marketplaceInvoices.length === 0 && <p style={{ color: "#999" }}>No invoices available for funding.</p>}
          </div>
        </section>
      </div>
    </div>
  );
}

const inputStyle = { width: "100%", padding: "12px", margin: "8px 0 20px 0", borderRadius: "8px", border: "1px solid #dee2e6", boxSizing: "border-box" };
const labelStyle = { display: "block", fontSize: "0.9em", fontWeight: "600", color: "#495057" };
const cardStyle = { padding: "20px", border: "1px solid #e9ecef", borderRadius: "12px", backgroundColor: "white", transition: "transform 0.2s" };

export default App;
